<template>
  <ui-dialog show max-width="542px" @input="$emit('close')">
    <template #header>
      <h3>
        {{ $t("message.questionsAndAnswers.deleteItemTitle") }}
      </h3>
    </template>

    <template #actions>
      <ui-button color="primary" outlined @click="$emit('close')">
        {{ $t("message.common.cancel") }}
      </ui-button>
      <ui-button color="red darken-1" @click="$emit('confirm')">
        {{ $t("message.common.yes") }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "QaListItemDeleteAlertDialog"
};
</script>

<style lang="scss" scoped>
::v-deep label,
::v-deep textarea {
  @include font-size(14px);
}
h3 {
  @include font-size(20px);
  margin-top: $spacing * 0.35;
}
</style>
